// This component is used to select a printer for printing receipts.
// It will only render itself onscreen if there are multiple printers available,
// but it will always handle automatically selecting a printer, including Cookie'ing the last printer used.
// It will also handle the case where the marina has added/removed printers since the last time the user was here.
// Check out usage of this component for more details on how to integrate it.
import Cookies from "js-cookie"
import ApplicationComponent from "legacy/ApplicationComponent"
import FormGroup from "legacy/FormGroup"
import PropTypes from "prop-types"
import React from "react"

class ReceiptPrinterChooser extends ApplicationComponent {
  constructor(props) {
    super(props)
    this.state = {
      printerId: this.getInitialPrinterId(),
    }

    this.handlePrinterSelection = this.handlePrinterSelection.bind(this)
    this.getInitialPrinterId = this.getInitialPrinterId.bind(this)
    this.printersEnabled = this.printersEnabled.bind(this)
    this.shouldRender = this.shouldRender.bind(this)
  }

  componentDidMount() {
    this.props.handlePrinterSelection(this.state.printerId)
  }

  getInitialPrinterId() {
    // Note: Cookie is loaded globally
    // ensure that the cookie'd printer ID exists at the marina (in case the marina added/removed printers since it was cookie'd)
    let printerId = this.props.printerId || Cookies.get("last-printer-id")
    const ids = this.props.printers.map((printer) => printer.id)

    if (!ids.includes(printerId)) {
      // Remove the cookie if the printer ID is no longer valid
      Cookies.remove("last-printer-id")
      printerId = ids[0]
    }

    return printerId
  }

  printersEnabled() {
    return this.props.printers.length > 0
  }

  shouldRender() {
    return (
      this.printersEnabled() &&
      (this.props.printers.length > 1 || this.props.alwaysShow)
    )
  }

  handlePrinterSelection(event) {
    const printerId = event.target.value
    // Note: Cookie is loaded globally
    Cookies.set("last-printer-id", printerId)
    this.setState({ printerId })
    this.props.handlePrinterSelection(printerId)
  }

  render() {
    if (!this.shouldRender()) return null
    return (
      <FormGroup
        inputType="select"
        label={this.props.title || "Select Printer"}
        name="printerId"
        value={this.state.printerId}
        onChange={this.handlePrinterSelection}
      >
        {this.props.noneOptionTitle && (
          <option value="none">{this.props.noneOptionTitle}</option>
        )}
        {this.props.printers.map((printer) => (
          <option key={printer.id} value={printer.id}>
            {printer.name}
          </option>
        ))}
      </FormGroup>
    )
  }
}

ReceiptPrinterChooser.propTypes = {
  printers: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
  handlePrinterSelection: PropTypes.func.isRequired,
  printerId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  alwaysShow: PropTypes.bool,
  title: PropTypes.string,
  noneOptionTitle: PropTypes.string,
}

ReceiptPrinterChooser.defaultProps = {
  printers: [],
  alwaysShow: false,
}

export default ReceiptPrinterChooser
